import type { QuantitySpec } from "#public"

export const Convert = <T extends number>(
  value: number,
  spec: QuantitySpec<T>,
  from: string,
  to: string
): number => (value * spec.units[from].magnitude) / spec.units[to].magnitude
